import {
  enqueueSnackbar as notistackEnqueueSnackbar,
  type OptionsObject,
  type SnackbarKey,
  type SnackbarMessage,
} from 'notistack';

type EnqueueSnackbar = (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey;

let enqueueSnackbarRef: EnqueueSnackbar | undefined;

export const bindSnackbar = (enqueueSnackbar: EnqueueSnackbar) => {
  enqueueSnackbarRef = enqueueSnackbar;
};

export const unbindSnackbar = () => {
  enqueueSnackbarRef = undefined;
};

export const enqueueAppSnackbar: EnqueueSnackbar = (message, options) => {
  const fallbackEnqueueSnackbar =
    typeof notistackEnqueueSnackbar === 'function' ? notistackEnqueueSnackbar : undefined;
  const enqueueSnackbar = enqueueSnackbarRef ?? fallbackEnqueueSnackbar;

  if (!enqueueSnackbar) {
    return '';
  }

  return enqueueSnackbar(message, options);
};
